// context/CTAContext.tsx
import { createContext, useContext, useState } from 'react'

type CTAContextType = {
  isCTAVisible: boolean
  setCTAVisible: (value: boolean) => void
}

const CTAContext = createContext<CTAContextType | null>(null)

export const CTAProvider = ({ children }: { children: React.ReactNode }) => {
  const [isCTAVisible, setCTAVisible] = useState(false)

  return (
    <CTAContext.Provider value={{ isCTAVisible, setCTAVisible }}>
      {children}
    </CTAContext.Provider>
  )
}

export const useCTAContext = () => {
  const context = useContext(CTAContext)
  if (!context) {
    throw new Error('useCTAContext must be used within a CTAProvider')
  }
  return context
}
